import React from 'react';

import tyria             from './img/art-pt2-world-map.jpg';
import clouds            from './img/clouds.png';
import emptyHeart        from './img/icon-pt2-wp-heart-empty.png';
import fullHeart         from './img/icon-pt2-wp-heart-full.png';
import emptyVista        from './img/icon-pt2-wp-vista-undiscovered.png';
import fullVista         from './img/icon-pt2-wp-vista-found.png';
import emptyPoi          from './img/icon-pt2-wp-poi-undiscovered.png';
import fullPoi           from './img/icon-pt2-wp-poi-discovered.png';
import emptyWaypoint     from './img/icon-pt2-wp-waypoint-undiscovered.png';
import fullWaypoint      from './img/icon-pt2-wp-waypoint-active.png';
import contestedWaypoint from './img/icon-pt2-wp-waypoint-contested.png';
import emptyHp           from './img/icon-pt2-wp-hero-point-unearned.png';
import fullHp            from './img/icon-pt2-wp-hero-point-earned.png';

import { i18n } from '../../i18n';

import SectionHeader from '../../section-header';

import * as css from './index.module.css';

const prefix = 'part2.it';

const items = [
    [
        {
            img   : [ emptyHeart, fullHeart ],
            label : `${prefix}.wp.rh.header`,
            copy  : `${prefix}.wp.rh.para.0`
        },
        {
            img   : [ emptyWaypoint, fullWaypoint, contestedWaypoint ],
            label : `${prefix}.wp.w.header`,
            copy  : `${prefix}.wp.w.para.0`
        }
    ],
    [
        {
            img   : [ emptyVista, fullVista ],
            label : `${prefix}.wp.v.header`,
            copy  : `${prefix}.wp.v.para.0`
        },
        {
            img   : [ emptyHp, fullHp ],
            label : `${prefix}.wp.hc.header`,
            copy  : `${prefix}.wp.hc.para.0`
        }
    ],
    [
        {
            img   : [ emptyPoi, fullPoi ],
            label : `${prefix}.wp.poi.header`,
            copy  : `${prefix}.wp.poi.para.0`
        }
    ]
];

function ListItem({ section }) {
    return (
        <div className={css.listCol}>
            <div className="flex">
                { section.img.map((img, idx) => (
                    <div className={css.iconContainer} key={idx}>
                        <img src={img}/>
                    </div>
                ))}
            </div>
            <h4 className={css.label}>{i18n(section.label)}</h4>
            <p>{i18n(section.copy)}</p>
        </div>
    );
}

function List() {
    return (
        <ul className={css.list}>
            {items.map((row, idx) => {
                const [ left, right ] = row;

                return <li className={css.cols} key={idx}>
                    <ListItem section={left} />
                    { right ? <ListItem section={right} /> : null}
                </li>;
            })}
        </ul>
    );
}

export default function IntoTyria() {
    return <>
        <SectionHeader name="into-tyria" />

        <div className='section'>
            <p className={css.para0}>{i18n(`${prefix}.para.0`)}</p>

            <div className={css.sec0}>
                <div className={css.col1}>
                    <div className={css.ex}>
                        <h3>{i18n(`${prefix}.ex.header`)}</h3>
                        <p>{i18n(`${prefix}.ex.para.0`)}</p>
                    </div>

                    <div>
                        <h3>{i18n(`${prefix}.wm.header`)}</h3>
                        <p>{i18n(`${prefix}.wm.para.0`, { doReplace : true })}</p>
                        <p>{i18n(`${prefix}.wm.para.1`)}</p>
                    </div>
                </div>
                <div className={css.tyriaWrap}>
                    <img className={css.clouds} src={clouds} />
                    <img className={css.tyria} src={tyria} />
                </div>
            </div>
        </div>

        <div className={css.listsContainer}>
            <div>
                <List />
            </div>
        </div>
    </>;
}

